// src/utils/laposta.js

import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

/**
 * Voegt een nieuw contact toe aan de Laposta mailinglijst via Strapi backend
 * De API credentials blijven veilig op de server
 *
 * @param {Object} userData - Gebruikersgegevens
 * @param {string} userData.email - E-mailadres van de gebruiker
 * @param {string} userData.fullName - Volledige naam van de gebruiker
 * @param {string} userData.educationRole - Rol in het onderwijs
 * @param {string} userData.educationRoleOther - Custom rol indien "anders"
 * @param {string} userData.educationSector - Onderwijssector
 * @param {string} [userData.schoolName] - Schoolnaam (optioneel)
 * @param {string} [userData.city] - Plaats (optioneel)
 * @returns {Promise<void>}
 */
export async function addToLapostaList(userData) {
  try {
    // Roep Strapi endpoint aan die de Laposta integratie afhandelt
    // API credentials blijven veilig op de backend
    const response = await axios.post(`${STRAPI_URL}/api/laposta/subscribe`, {
      email: userData.email,
      fullName: userData.fullName,
      educationRole: userData.educationRole,
      educationRoleOther: userData.educationRoleOther,
      educationSector: userData.educationSector,
      schoolName: userData.schoolName,
      city: userData.city,
    });

    if (!response.data.success) {
      console.warn('Laposta subscription failed:', response.data.message);
    }
  } catch (error) {
    // Log de fout maar gooi geen error - we willen niet dat registratie faalt
    // als de Laposta integratie niet werkt
    console.error('Failed to add to Laposta:', error.response?.data || error.message);
  }
}
